import { AxiosError } from "axios";
import type { User } from "@/types";

const MOCK_SSO_USER: User = {
  id: "mock-sso-user-001",
  email: "testuser@pwc.com",
  phone: "01012345678",
  company_name: "PwC Korea",
  ceo_name: "홍길동",
  requester_name: "김테스트",
  department: "Digital Innovation",
  position: "Manager",
  job_title: "Software Engineer",
  company_country: "Korea",
  is_email_verified: true,
  status: "active",
  // The real /users/me always sends access_level (accessLevelOf treats a missing one as guest)
  user_type: "demand",
  access_level: "demand",
  created_at: "2026-01-01T00:00:00Z",
  last_login_at: new Date().toISOString(),
};

const MOCK_TOKENS = {
  access_token: import.meta.env.VITE_MOCK_ACCESS_TOKEN || `mock-${Date.now()}-access`,
  refresh_token: import.meta.env.VITE_MOCK_REFRESH_TOKEN || `mock-${Date.now()}-refresh`,
  token_type: "bearer" as const,
  expires_in: 3600,
};

export const mockSsoService = {
  async getLoginUrl() {
    const redirectUri = import.meta.env.VITE_ENTRA_REDIRECT_URI || `${window.location.origin}/login`;
    return `${redirectUri}?code=mock-auth-code-12345`;
  },

  async exchangeToken(_code: string) {
    await delay(300);
    return {
      access_token: import.meta.env.VITE_MOCK_ACCESS_TOKEN || `mock-${Date.now()}-entra-access`,
      refresh_token: import.meta.env.VITE_MOCK_REFRESH_TOKEN || `mock-${Date.now()}-entra-refresh`,
    };
  },

  getLogoutUrl() {
    return window.location.origin + "/login";
  },
};

export const mockAuthService = {
  async ssoLoginUser(_accessToken: string) {
    await delay(300);
    // DEV: simulate the backend's login refusal codes to check the login guidance box,
    // e.g. localStorage.setItem("__mock_sso_error", "ACCOUNT_REJECTED")
    const mockError = localStorage.getItem("__mock_sso_error");
    if (mockError) {
      const status = mockError === "NOT_REGISTERED" ? 404 : 403;
      const response = { status, statusText: "", headers: {}, config: {} as never, data: { success: false, data: null, error: { code: mockError, message: mockError } } };
      throw new AxiosError(mockError, String(status), undefined, undefined, response as never);
    }
    return MOCK_TOKENS;
  },

  async getCurrentUser(): Promise<User> {
    await delay(100);
    return MOCK_SSO_USER;
  },
};

function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
